import { render, staticRenderFns } from "./TagUser.vue?vue&type=template&id=08f8e05c&scoped=true"
import script from "./TagUser.vue?vue&type=script&lang=js"
export * from "./TagUser.vue?vue&type=script&lang=js"
import style0 from "./TagUser.vue?vue&type=style&index=0&id=08f8e05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8e05c",
  null
  
)

export default component.exports